module.exports = __webpack_public_path__ + "static/img/infoWorld.7b72b3ec.png";